import { use } from 'echarts/lib/echarts';
import { install } from './polygons3D/install';
use(install);